<script setup lang="ts">
import EpIconButton from '~/components/button/EpIconButton.vue'
import { CHAIN } from '~/constants/default.constants'
import { IMAGE } from '~/constants/image.constants'
import { routes } from '~/routes'

interface IProps {
  isSidebarOpen: boolean
}

defineProps<IProps>()

const emits = defineEmits([ 'update:setMobileSearchOpen', 'update:setSidebarOpen' ])
</script>

<template>
  <header class="header-container">
    <h1 class="logo">
      <NuxtLink :to="routes.getRootPage()">
        <NuxtImg
          class="h-6"
          :src="IMAGE.logo"
          :alt="`${CHAIN} Community Hub`"
        />
      </NuxtLink>
    </h1>
    <EpIconButton
      icon-name="search"
      :icon-size="20"
      :value="true"
      @click="emits('update:setMobileSearchOpen')"
    />
    <EpIconButton
      :icon-name="isSidebarOpen ? 'close' : 'menu'"
      :icon-size="20"
      @click="emits('update:setSidebarOpen')"
    />
  </header>
</template>

<style scoped lang="scss">
.header-container {
  @apply flex w-full items-center justify-end border-b-4 bg-black p-2;
  border-image: linear-gradient(90deg, #E99E52, #97D9D7, #E99E52) 1;

  .logo {
    @apply shrink-0 mr-auto;
  }
}

</style>